const ExtendedPool = require('ExtendedPool');
const hideTween = { scale: 0 };
const moveEasing = { easing: 'sineInOut' };
let tCoef = 1;

cc.Class({
    extends: cc.Component,

    properties: {
        blockPrefab: cc.Prefab,
        itemPrefab: cc.Prefab,
    },

    onLoad () {
        this.gridSize = { width: this.blockPrefab.data.width, height: this.blockPrefab.data.height };
        // this.gridSize = { width: 185, height: 180 };
        this.pool = new ExtendedPool(this.itemPrefab, 5);
        this.actives = [];
    },

    init (data) {
        while(this.actives.length) {
            this._hideItem(this.actives.pop());
        }
        this.data = data.slice(0);
        this.data.forEach((dataItem) => this._showItem(this.pool.get(), dataItem));
    },

    spin (isFast) {
        this.isSpinning = true;
        tCoef = isFast ? 0.5 : 1;

        let c = this.actives.length * tCoef;
        while(this.actives.length) {
            this._hideItem(this.actives.pop(), c * 0 + 0.2 * tCoef);
            c --;
        };
    },

    place(data, isFast) {
        return new Promise(resolve => {
            this.data = data.slice(0);

            tCoef = isFast ? .5 : 1;
            this.data.forEach(dataItem => this._showItem(this.pool.get(), dataItem));

            // if (this.actives.length <= this.data.length) {

            //     for(let i = 0; i < this.data.length; i++) {
            //         if (i < this.actives.length) {
            //             this._moveItem(this.actives[i], this.data[i]);
            //         } else {
            //             this._showAndMoveItem(this.pool.get(), this.data[i], this.actives[0].position);
            //         }
            //     }
            // } else if (this.actives.length > this.data.length) {
            //     for(let i = 0; i < this.actives.length; i++) {
            //         if (i < this.data.length) {
            //             this._moveItem(this.actives[i], this.data[i]);
            //         } else {
            //             this._moveAndHideItem(this.actives[i], this._getPos(this.data[0].row, this.data[0].reel));
            //         }
            //     }
            // }
            // resolve();
            this.scheduleOnce(resolve, this.data.length * 0.1 * tCoef + 0.1 * tCoef);
        });
    },

    getItem(row, reel) {
        for (let i = 0; i < this.data.length; i ++) {
            const dataItem = this.data[i];
            if (row === dataItem.row && reel === dataItem.reel) {
                return dataItem.item;
            }
        }

        return null;
    },

    _moveAndHideItem(item, position) {
        cc.tween(item).to(0.2, position, moveEasing).call(() => {
            this.actives = this.actives.filter(a => a !== item);
            this.pool.set(item);
        }).start();
    },

    _showAndMoveItem(item, dataItem, position) {
        const { row, reel, multiplier } = dataItem;
        const pos = this._getPos(row, reel);
        item.active = true;
        item.parent = this.node;
        item.x = position.x;
        item.y = position.y;

        dataItem.item = item;

        const spine = item.getComponentInChildren(sp.Skeleton);

        spine.setSkin(`x${multiplier}`);
        spine.setAnimation(0, 'idle1', true);
        cc.tween(item).to(0.2, pos, moveEasing).start();
        this.scheduleOnce(() => {
        }, 0.1);

        this.actives.push(item);
    },

    _moveItem(item, dataItem) {
        const { row, reel, multiplier } = dataItem;
        const pos = this._getPos(row, reel);
        item.active = true;
        item.parent = this.node;

        const spine = item.getComponentInChildren(sp.Skeleton);
        spine.setSkin(`x${multiplier}`);
        spine.setAnimation(0, 'idle1', true);

        dataItem.item = item;
        cc.tween(item).to(0.2, pos, moveEasing).start();
    },

    _hideItem (item, delay = 0) {
        item.tween = cc.tween(item).delay(delay).to(0.1, hideTween, { esing: 'backIn' }).call(() => {
            this.pool.set(item);
        }).start();
    },

    _showItem (item, dataItem) {
        const { row, reel, multiplier } = dataItem;
        const pos = this._getPos(row, reel);
        item.opacity = 0;
        item.active = true;
        item.parent = this.node;
        item.x = pos.x;
        item.y = pos.y;

        dataItem.item = item;

        // const multiplier = 2;
        const spine = item.getComponentInChildren(sp.Skeleton);

        this.scheduleOnce(() => {
            item.opacity = 255;
            spine.setSkin(`x${multiplier}`);
            spine.setAnimation(0, 'idle1', true);
            item.scale = 0;
            cc.tween(item).to(0.1, { scale: 1 }, { easing: 'backOut' }).start();
        }, (this.actives.length * 0.1) * tCoef);

        this.actives.push(item);
    },

    _getPos (row, reel) {
        return {
            x: (reel - 2.5) * this.gridSize.width,
            y: -(row + 0.5) * this.gridSize.height
        }
    }

});
